export default function Button ({
  children,
  onClick,
  filled = false,
  className = "",
  ...props
}) {
  const baseClasses = "border-2 border-bluekali-white rounded-full px-8 py-2";
  const fillClass = filled ? "bg-bluekali-white" : "";
  
  return (
    <button
      onClick={onClick}
      {...props}
      className={`${baseClasses} ${fillClass} ${className}`}
    >
      {children}
    </button>
  );
};